const dataRecycle = [
  {
    title: "Plastik",
    content:
      "Agar sampah plastik dapat didaur ulang, beberapa hal perlu diperhatikan, antara lain:\n1. Pengumpulan dan pemilahan Sebelum mendaur ulang plastik, sangat penting untuk mengumpulkan dan memilahnya.\n2. Pembersihan plastik Untuk mendaur ulang plastik, pastikan juga sampah plastik tersebut bersih dan bebas dari kotoran. Karena adanya kotoran pada plastik dapat merusak produk daur ulang. Daur ulang saja tidak akan cukup. Untuk mengatasi masalah plastik harus dibarengi dengan kesadaran untuk mengurangi penggunaan plastik dan kebijakan yang menyertainya.",
    image: "url(./images/a.jpg)",
  },
  {
    title: "Kertas",
    content:
      "Proses daur ulang kertas sampai menjadi kertas baru :\n1. Pengumpulan\n Merupakan langkah awal dalam proses daur ulang.\n2. Pemilihan kertas\nKertas yang kualitas sama akan digabungkan.\n3. Proses bubur\nKertas diparut dan menjadi potongan kecil.\n4. Proses Penghilangan tinta\nMenambahkan pulp untuk menghilangkan tinta\n5. Pengeringan",
    image: "url(./images/b.jpg)",
  },
  {
    title: "Kaca",
    content:
      "Sortir kaca bekas sebelum didaur ulang, cuci, lalu dihancurkan, agar bisa diubah menjadi bahan baku yang disebut serpihan. seperti batugamping atau kapur, pasir dan soda. Campuran tersebut kemudian dipanaskan hingga suhu 1426 derajat Celcius, bahan pembuat kaca akan meleleh, cairan cetakan akan mendingin dan menjadi produk kaca baru.",
    image: "url(./images/c.jpg)",
  },
];

export default dataRecycle;
